// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/gutenberg/acf-center-text-block/index.js'; import '../blocks/gutenberg/acf-collage-block/index.js'; import '../blocks/gutenberg/acf-contact-block/index.js'; import '../blocks/gutenberg/acf-cta-banner-block/index.js'; import '../blocks/gutenberg/acf-example-block/index.js'; import '../blocks/gutenberg/acf-gallery-block/index.js'; import '../blocks/gutenberg/acf-hero-section/index.js'; import '../blocks/gutenberg/acf-info-banner-block/index.js'; import '../blocks/gutenberg/acf-large-image-block/index.js'; import '../blocks/gutenberg/acf-map-block/index.js'; import '../blocks/gutenberg/acf-residents-block/index.js'; import '../blocks/gutenberg/acf-two-columns-block/index.js'; import '../blocks/gutenberg/acf-zigzag-block/index.js';
import { log } from 'debug';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function checkVisibility() {
  let $grand = $('.grand');

  if ($grand.length === 0) return;

  let windowHeight = $(window).height();
  let windowWidth = $(window).width();
  let scrollTop = $(window).scrollTop();

  let visibilityThreshold = windowWidth < 1024 ? 0.7 : 0.2;

  $grand.each(function () {
    let $this = $(this);
    let elementOffset = $this.offset().top;
    let elementHeight = $this.outerHeight();

    let elementBottom = elementOffset + elementHeight;
    let viewportBottom = scrollTop + windowHeight;

    let elementVisible =
      elementBottom > scrollTop + windowHeight * visibilityThreshold &&
      elementOffset < viewportBottom - windowHeight * visibilityThreshold;

    if (elementVisible) {
      $this.addClass('grand--visible');
    }
  });
}

function animateLisleToComing() {
  const $coming = $('.more-links');
  const $lisleSelection = $('.home-slide__big_wrapper-image');

  if ($coming.length === 0 || $lisleSelection.length === 0) return;

  const comingOffset = $coming.offset();
  if (!comingOffset) return;

  const $lisle = $lisleSelection[0];
  const windowWidth = $(window).width();
  let targetRight;

  if (windowWidth <= 640) {
    targetRight = '15px';
  } else {
    const rightEdge = windowWidth;
    const offset = rightEdge - comingOffset.left - $coming.outerWidth();
    targetRight = `${offset}px`;
  }

  $lisle.style.setProperty('--lisle-right', targetRight);

  $lisle.classList.remove('animate');
  void $lisle.offsetWidth;
  $lisle.classList.add('animate');
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  $('.filter-span.floor').on('click', function () {
    $('.filter-span').removeClass('is-active');
    $(this).addClass('is-active');
    $('.floorplans-grid').show();
    $('.def-filter').show();
    $('.floorplans-section iframe').addClass('is-hidden');
  });

  $('.filter-span.map').on('click', function () {
    $('.filter-span').removeClass('is-active');
    $(this).addClass('is-active');
    $('.floorplans-grid').hide();
    $('.def-filter').hide();
    $('.floorplans-section iframe').removeClass('is-hidden');
  });
  $(document).on('click', '.label_price', function () {
    $('.facetwp-facet-move_in_date, .facetwp-facet-square_feet').removeClass(
      'is-open'
    );
    $('.facetwp-facet-price').toggleClass('is-open');
  });

  $(document).on('click', '.label_date', function () {
    $('.facetwp-facet-price, .facetwp-facet-square_feet').removeClass(
      'is-open'
    );
    $('.facetwp-facet-move_in_date').toggleClass('is-open');
  });

  $(document).on('click', '.label_feet', function () {
    $('.facetwp-facet-price, .facetwp-facet-move_in_date').removeClass(
      'is-open'
    );
    $('.facetwp-facet-square_feet').toggleClass('is-open');
  });

  $('.menu-icon').on('click', function () {
    $('header').toggleClass('active');
    $('.header-banner').toggleClass('active');
  });
  $('body').on('click', 'a[href="#target_book_tour_button"]', function (e) {
    e.preventDefault();
    let hiddenBtn = $('.book_tour_button')[0];
    if (hiddenBtn) {
      hiddenBtn.click();
    }
  });
  $('body').on('click', 'a[href="#target_contact_us_button"]', function (e) {
    e.preventDefault();
    let hiddenBtn = $('.join');
    hiddenBtn.toggleClass('moved');
  });
  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }
  animateLisleToComing();
  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  let $section = $('.after-slider');
  let $images = $('.after-slider__image');
  let startOffsets = {};
  let initialOffset = 100;
  if ($('body').hasClass('home') && $section.length && $images.length) {
    $images.each(function (index) {
      let matrix = $(this).css('transform');
      let translateY =
        matrix !== 'none' ? parseFloat(matrix.split(',')[5]) || 0 : 0;
      startOffsets[index] = translateY + initialOffset;
      $(this).css('transform', `translateY(${startOffsets[index]}px)`);
    });

    $(window).on('scroll', function () {
      let scrollTop = $(window).scrollTop();
      let sectionTop = $section.offset().top;
      let sectionHeight = $section.outerHeight();
      let windowHeight = $(window).height();

      if (
        scrollTop + windowHeight > sectionTop + sectionHeight * 0.2 &&
        scrollTop < sectionTop + sectionHeight
      ) {
        $images.each(function (index) {
          let speed = (index + 1) * 0.2;
          let offset = (scrollTop - sectionTop) * -speed;

          let newOffset = Math.max(
            startOffsets[index] - 100,
            Math.min(startOffsets[index] + 100, offset + startOffsets[index])
          );

          $(this).css('transform', `translateY(${newOffset}px)`);
        });
      } else {
        $images.each(function (index) {
          let resetOffset = index === 2 ? -60 : 0;
          $(this).css('transform', `translateY(${resetOffset}px)`);
        });
      }
    });
  }
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
  $('.slides__slider').slick({
    autoplay: true,
    draggable: true,
    arrows: false,
    dots: false,
    fade: true,
    speed: 2000,
    infinite: true,
    cssEase: 'ease',
    touchThreshold: 100,
    pauseOnHover: false,
  });
  $(document).on('click', function (e) {
    const isClickInsideJoin = $(e.target).closest('.join').length > 0;
    const isClickOnTriggerBtn =
      $(e.target).closest('a[href="#target_contact_us_button"]').length > 0;

    if (!isClickInsideJoin && !isClickOnTriggerBtn) {
      $('.join').removeClass('moved');
    }
  });

  $('.join').on('click', function () {
    $(this).toggleClass('moved');
  });
  $('.join form').on('click', function (e) {
    e.stopPropagation();
  });
  //Line animation
  let $list = $('.animated-line__list');
  let listWidth = 0;

  $list.children().each(function () {
    listWidth += $(this).outerWidth(true);
  });

  $list.append($list.html());

  function animateLine() {
    $list.css('transform', 'translateX(0)');
    $list.animate(
      { transform: -listWidth },
      {
        step: function (now) {
          $(this).css('transform', `translateX(${now}px)`);
        },
        duration: 60000,
        easing: 'linear',
        complete: animateLine,
      }
    );
  }

  animateLine();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  checkVisibility();
  resizeVideo();
  animateLisleToComing();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  checkVisibility();
});
